import { IconButton } from '@atlaskit/atlassian-navigation';
import AddIcon from '@atlaskit/icon/core/add';
import ProjectIcon from '@atlaskit/icon/core/project';
import {
	ExpandableMenuItem,
	ExpandableMenuItemContent,
	ExpandableMenuItemTrigger,
} from '@atlaskit/navigation-system/side-nav-items/expandable-menu-item';
import { useIntl } from 'react-intl-next';
import type { PreloadedQuery } from 'react-relay';

import { useCreateFlowSession } from '../../hooks/use-create-flow';
import { useRepositoryModal } from '../../page-home/components/repository-modal';

import type { sessionsListQuery } from './__generated__/sessionsListQuery.graphql';
import messages from './messages';
import { SessionsList } from './sessions-list';

export const SessionsButton = ({
	queryRef,
}: {
	queryRef?: PreloadedQuery<sessionsListQuery> | null;
}) => {
	const { formatMessage } = useIntl();
	const [createFlow, isPending] = useCreateFlowSession();
	const { openModal, closeModal, RepositoryModal } = useRepositoryModal({
		branchName: `NO-ISSUE-${Date.now()}`,
		onConfirm: (repositoryUrl, branchName, prompt) => {
			createFlow({
				repoUrl: repositoryUrl,
				branchName,
				prompt,
				onSuccess: () => {
					closeModal();
				},
			});
		},
		isSubmitPending: isPending,
	});

	return (
		<>
			<ExpandableMenuItem isDefaultExpanded>
				<ExpandableMenuItemTrigger
					elemBefore={<ProjectIcon label="" />}
					actions={
						<IconButton
							onClick={openModal}
							tooltip={formatMessage(messages.newSessionTooltip)}
							icon={<AddIcon label="" />}
						/>
					}
				>
					{formatMessage(messages.sessionsButtonLabel)}
				</ExpandableMenuItemTrigger>
				<ExpandableMenuItemContent>
					{queryRef != null && <SessionsList queryRef={queryRef} />}
				</ExpandableMenuItemContent>
			</ExpandableMenuItem>
			{RepositoryModal}
		</>
	);
};
